import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { SalesByPartComponent } from './sales-by-part/sales-by-part.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { OrderSearchComponent } from 'app/orders/order-search/order-search.component';
import { SalesCommissionComponent } from './sales-comimission/sales-commission.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'sales-reporting',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    {
                        path: 'by-part',
                        component: SalesByPartComponent,
                        data: { title: 'Sales By Parts' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'quotes',
                        component: OrderSearchComponent,
                        data: { title: 'Quotes' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'commissions',
                        component: SalesCommissionComponent,
                        data: { title: 'Commissions' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],

    declarations: [SalesByPartComponent, SalesCommissionComponent],
})
export class SalesModule {}